jQuery(document).ready(function ($) {
  console.log('Sleepless Initialized');

  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  var currentQty = $('[data-header-cart-count]').first().attr('data-header-cart-count');

  var templateElement = $('.miniRecProd--template')
  templateElement.removeClass('miniRecProd--template');
  var template = templateElement.clone(false);

  var modalOpen = false;
  var numberOfLines = 0;
  
  $('.miniCart__recColumn').html('');

  // ---- Drawer control -------------------------------------------------
  // Opening the drawer used to depend on the theme's .product-add-popdown class.
  // That only appears when the THEME performs the add. Globo (and SC) add via their
  // own AJAX, so the popdown never fires and the drawer never opens. This helper is
  // driven by actual /cart/add.js traffic instead, so it works no matter which app
  // performed the add.
  function openCartDrawer(){
    if (!cartDrawer) return;
    // Don't hijack the full cart page
    if (window.location.pathname.indexOf('/cart') === 0) return;
    // Already open? nothing to do
    if ($('.cart__drawer').hasClass('drawer--visible')) return;

    cartDrawer.dispatchEvent(
      new CustomEvent('theme:drawer:open', { bubbles: false })
    );
  }

  var cartCheck = setInterval(function(){
    var headerQty = $('[data-header-cart-count]').first().attr('data-header-cart-count');

    if ($('.product-add-popdown').hasClass('is-visible') && currentQty != headerQty){
      $('.product-add-popdown').removeClass('is-visible');
      openCartDrawer();
      currentQty = headerQty;
      updateLocalCartData();
    }

    if ($('.cart__drawer').hasClass('drawer--visible') && currentQty != headerQty){
      currentQty = headerQty;
      updateLocalCartData();
    }

    if ($('iframe.clyde-modal').is(':visible')){
      if (modalOpen == false){
        modalOpen = true;
      }
    }
    else{
      if (modalOpen == true){
        
        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
        updateLocalCartData();
        
        modalOpen = false;
      }
    }

    
    
  }, 100);

  function getCartData(){
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { return data });
    return cartContents;
  }

  function updateLocalCartData(){
    getCartData().then(
      function(value) {
        cartData = { ...value }; //shallow copy
        console.log(cartData);
        loadRecommendedIntoMinicart();
      }
    );
  }
  updateLocalCartData();

  // ---- Cart add interceptor -------------------------------------------
  // Watches every successful /cart/add.js request, whoever made it: the theme,
  // Globo, SC, or our own addToCartSleepless(). Debounced because Globo may fire
  // several sequential adds (main product, then each addon) for a single click.
  //
  // IMPORTANT LIMITATION: this is inert when Globo add-on products are involved.
  // In that case Globo performs a NATIVE form POST to /cart/add and Shopify 302s
  // to /cart, so there is no XHR/fetch to observe and the page unloads anyway.
  // This only earns its keep if the Globo "Redirect to the shopping cart page
  // after adding a product" setting is disabled AND Globo switches to an AJAX add.
  // Set to false to remove the global fetch/XHR patching entirely.
  // DISABLED: opening the drawer from this watcher races the theme's own cart
  // render — the drawer opens before its contents update, appearing empty until
  // closed and reopened. The popdown/interval path below waits for the theme to
  // finish and does not have this problem. Leave false unless Globo enables an
  // AJAX add for add-on products AND the open is re-sequenced after render.
  var SS_ENABLE_CART_ADD_WATCHER = false;

  (function watchCartAdds(){
    if (!SS_ENABLE_CART_ADD_WATCHER) return;
    var addTimer = null;

    function noteCartAdd(){
      clearTimeout(addTimer);
      addTimer = setTimeout(function(){
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        updateLocalCartData();
        openCartDrawer();
      }, 450);
    }

    function isAddUrl(url){
      return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    }

    // fetch()
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function(){
        var input = arguments[0];
        var url = (input && input.url) ? input.url : String(input);
        var promise = nativeFetch.apply(this, arguments);

        if (isAddUrl(url)) {
          promise.then(function(res){
            if (res && res.ok) noteCartAdd();
          }).catch(function(){ /* swallow: never break the caller's chain */ });
        }
        return promise;
      };
    }

    // XMLHttpRequest (jQuery $.ajax and older app code)
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url){
      this.__ssCartAddUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(){
      var xhr = this;
      if (isAddUrl(xhr.__ssCartAddUrl)) {
        xhr.addEventListener('load', function(){
          if (xhr.status >= 200 && xhr.status < 300) noteCartAdd();
        });
      }
      return nativeSend.apply(this, arguments);
    };
  })();

  function getMostExpensive(){
    var items = cartData.items;
    if (items.length > 0){
      var highProd = items[0];
      var highPrice = items[0].price;
      for (i=0;i<items.length;i++){
        if (items[i].price > highPrice){
          highPrice = items[i].price;
          highProd = items[i];
        }
      }
      return highProd;
    }
    return false;
  }

  function fetchAndProcessContent(url, className, callback) {
      $.ajax({
          url: url,
          method: 'GET',
          success: function(data) {
              var tempDiv = $('<div>').html(data);
              var extractedContent = tempDiv.find('.' + className).text();
              if (typeof callback === 'function') {
                  callback(extractedContent);
              }
          },
          error: function(xhr, status, error) {
              console.error('Error fetching data:', error);
          }
      });
  }

  function renderProd(template, product){
    console.log(product);
    if (product.images.length > 0){
      template.find('.miniRecProd__image').attr('src', product.media[0].src);
      template.find('.miniRecProd__image').attr('alt', product.media[0].alt);
    }
    else{
      template.find('.miniRecProd__image').attr('src', 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_300x.gif');
      template.find('.miniRecProd__image').attr('alt', "no image");
      
    }
    template.find('.miniRecProd__title').text(product.title);
    template.find('.miniRecProd__title').attr('href', product.url);
    template.find('.miniRecProd__brand').text(product.vendor);
    template.find('.miniRecProd__price').text('$' + (product.price / 100).toFixed(2));
    template.find('.miniRecProd__addButton').attr('data-id', product.variants[0].id);
    template.find('.miniRecProd__addButton').attr('data-handle', product.handle);
    template.find('.miniRecProd__addButton').on('click', function(){
      addToCartSleepless($(this).attr('data-id') * 1, 1);
      $(this).closest('.miniRecProd').remove();
    });
    if (product.available == true){
      $('.miniCart__recColumn').append(template);
    }
    

    if ($('.miniRecProd').length){
      $('.miniCart__rec').show();
    }
    else{
      $('.miniCart__rec').hide();
    }
  };

  function getAndRendProd(handle, template){
    if (!handle || handle.trim() === '') {
      console.warn('getAndRendProd: Empty handle provided');
      return;
    }
    
    fetch('/products/'+handle+'.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Product fetch failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(product => renderProd(template, product))
      .catch(error => console.warn('Error fetching product:', handle, error));
  };

  function chooseAndRenderRecommended(handleString){
    var handles = handleString.split(',');
    var finalHandles = [];
    if (handles.length > 3){
      for (i=0;i<3;i++){
        finalHandles[i] = handles[i].trim();
      }
    }
    else{
      for (i=0;i<handles.length;i++){
        finalHandles[i] = handles[i].trim();
      }
    }

    var inCartHandles = [];
    for (i=0;i<cartData.items.length;i++){
      inCartHandles.push(cartData.items[i].handle);
    }
    console.log(inCartHandles);
    
    if (finalHandles.length > 0){
      $('.miniCart__recColumn').html('');
      
      for (i=0;i<finalHandles.length;i++){
        console.log(finalHandles[i]);
        console.log(inCartHandles);
        var isInCart = inCartHandles.indexOf(finalHandles[i]);
        console.log(isInCart);
        if (isInCart == -1){
          getAndRendProd(finalHandles[i], template.clone(false));
        }
        
      }
    }
  }

  function loadRecommendedIntoMinicart(){
    if (cartData.items.length > 0){
      var target = getMostExpensive();
      var handle = target.handle;
      var urlString = "/products/" + handle + "?view=minicart-metafield-fetch"
      fetchAndProcessContent(urlString, 'recommendedProds', chooseAndRenderRecommended);
    }
  }

  // ---- State ----
var cartChanging = false;

// ---- Public API ----
function addToCartSleepless(id, quantity = 1) {
  cartChanging = true;

  const payload = {
    items: [{ id, quantity }]
  };

  fetch(`${Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(assertOk)
    .then(res => res.json())     // add.js response (line items added)
    .then(onAddSuccess)
    .catch(onAddError);
}

// ---- Handlers ----
function onAddSuccess(/* addedItems */) {
  // Get the fresh cart (with updated total_price) before dispatching
  fetchCart()
    .then(cart => {
      dispatchCartChange(cart);  // <-- the theme listener needs detail.cart
      dispatchCartReload();      // if your theme repaints minicart on this
      toggleMiniCartRecs();
      cartChanging = false;
    })
    .catch(onAddError);
}

function onAddError(err) {
  console.warn('Add to cart error:', err);
  cartChanging = false;
}

// ---- Utilities ----
function fetchCart() {
  return fetch(`${Shopify.routes.root}cart.js`, {
    headers: { 'Accept': 'application/json' }
  })
    .then(assertOk)
    .then(res => res.json());
}

function dispatchCartChange(cart) {
  document.dispatchEvent(new CustomEvent('theme:cart:change', {
    bubbles: true,
    detail: { cart } // REQUIRED by CartShippingMessage.listen()
  }));
}

function dispatchCartReload() {
  document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
}

function toggleMiniCartRecs() {
  var hasRecs = !!document.querySelector('.miniRecProd');
  document.querySelectorAll('.miniCart__rec').forEach(el => {
    el.style.display = hasRecs ? '' : 'none';
  });
}

function assertOk(res) {
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res;
}

  function onError(data) {
    let text = 'Network error: please try again';
    console.log(text);
    cartChanging = false;
  }

  function updateHeaderTotal() {
    $.ajax({
      url: window.Shopify.routes.root + '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function(response) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response,
            },
            bubbles: true,
          })
        );
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
      }
    });
  }

});

jQuery(document).ready(function ($) {
  
  function mobVehicleWidget(){
    console.log('test');
    if ($(window).width() < 1050) {
      $('#cm_vehicle-widget__search .cm_vehicle-widget_body').hide();
    } else {
      $('#cm_vehicle-widget__search .cm_vehicle-widget_body').show();
    }
  }
  var hideInterval = setInterval(function(){
    if ($('#cm_vehicle-widget__search .cm_vehicle-widget_body').length > 0){
      mobVehicleWidget();
      clearInterval(hideInterval);

      $('#cm_vehicle-widget__search .cm_vehicle-widget_title').on('click', function(){
        if ($(window).width() < 1050) {
          if ($(this).parent().hasClass('openAccordion')){
            $(this).parent().removeClass('openAccordion');
            $('#cm_vehicle-widget__search .cm_vehicle-widget_body').slideUp();
          }
          else{
            $(this).parent().addClass('openAccordion');
            $('#cm_vehicle-widget__search .cm_vehicle-widget_body').slideDown();
          }
        }
      });
    }
  }, 10);
  
  
  $(window).on('resize, ready', function() {
    mobVehicleWidget();
  });

  if ($('.smStickyBuy__button').length > 0){
    
    // Create a new MutationObserver to track added nodes
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Check for added nodes
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            // Ensure it's an element and check if it has the desired class
            if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('richpanel-micro')) {
              // Disconnect the observer
              observer.disconnect();
    
              // Find the .smStickyBuy__inner element and add the class
              const stickyBuyInner = document.querySelector('.smStickyBuy__inner');
              if (stickyBuyInner) {
                stickyBuyInner.classList.add('smStickyBuy__inner--chatLoaded');
              }
    
              // Since we only need to handle this once, we can return to stop checking
              return;
            }
          }
        }
      }
    });
    
    // Start observing the body for child additions
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    

    if ($('.stock-info').hasClass('out-of-stock')){
      $('.smStickyBuy__button').addClass('smStickyBuy__button--oos');
      $('.smStickyBuy__button').addClass('klaviyo-bis-trigger');
      $('.smStickyBuy__buttonText').text('Notify Me');
    }
    //check and set disabled if out of stock on load.
  }

  $('.smStickyBuy__button').on('click', function(){
    if ($(this).hasClass('smStickyBuy__button--oos')){
      var $element = $('.product__submit__buttons a.klaviyo-bis-trigger');
      var elementOffset = $element.offset().top;
      var elementHeight = $element.outerHeight();
      var windowHeight = $(window).height();
      
      var scrollPosition = elementOffset - (windowHeight / 2) + (elementHeight / 2);

      $('html, body').animate({
        scrollTop: scrollPosition
      }, 500);
      
      $('.product__submit__buttons a.klaviyo-bis-trigger').click();
    }
    else {
      // Click whichever ATC button is actually VISIBLE.
      // Globo clones the theme button and binds its option/addon logic to the CLONE.
      // The .gpo-original-atc-button is the theme's button and bypasses Globo, so we
      // must never target it directly while Globo is active. Going by visibility keeps
      // this app-agnostic: it works for the Globo clone, for SC, and for the native
      // theme button once both apps are removed.
      var $candidates = $('.product__submit__buttons')
        .find('button[name="add"], button[type="submit"]')
        .not('[disabled]');

      var $button = $candidates.filter(':visible').first();

      // Fallbacks if nothing reports as visible (e.g. sticky bar shown before layout settles)
      if (!$button.length) {
        $button = $candidates.filter('.gpo-clone-atc-button').first();
      }
      if (!$button.length) {
        $button = $candidates.first();
      }

      if (!$button.length) {
        console.warn('Sticky ATC: No add-to-cart button found in .product__submit__buttons');
        return;
      }

      // Scroll to the button
      var elementOffset = $button.offset().top;
      var elementHeight = $button.outerHeight();
      var windowHeight = $(window).height();
      var scrollPosition = elementOffset - (windowHeight / 2) + (elementHeight / 2);

      $('html, body').animate({
        scrollTop: scrollPosition
      }, 500, function() {
        // After scroll completes, click the button
        // Use native click, not jQuery trigger, to ensure proper event propagation
        $button[0].click();
      });
    }
  });
  
  const swiperPDPVids = new Swiper('.prodVidGallery__sliderWrapper', {
    loop: true,
    spaceBetween: 18,
    slidesPerView: 1.5,
    centeredSlides: true,
    navigation: {
      nextEl: '.prodVidGallery__next',
      prevEl: '.prodVidGallery__prev'
    },
    breakpoints: {
      800: {
        slidesPerView: 2,
        centeredSlides: false
      },
      1000: {
        slidesPerView: 4,
        centeredSlides: false
      }
    }
  });

  const swiperPDPReviews = new Swiper('.prodRevsNew__flex', {
    loop: false,
    spaceBetween: 18,
    slidesPerView: 1.5,
    breakpoints: {
      800: {
        slidesPerView: 2,
        centeredSlides: false
      },
      1000: {
        slidesPerView: 3,
        centeredSlides: false
      }
    }
  });



  $('.prodVid__clickableContainer').on('click', function () {
  var thisIndex = $(this).attr('data-button-index') * 1;
  var thisSection = $(this).closest('.shopify-section');

  // Show the popup
  thisSection.find('.prodGalleryPopup').fadeIn(200, function () {
      // Hide all video buckets first
      thisSection.find('.prodGalleryPopup__vidBucket').hide();

      // Show only the selected one
      var $bucket = thisSection.find('.prodGalleryPopup__vidBucket[data-video-index="' + thisIndex + '"]');
      $bucket.show();

      // Only proceed if it's a native video upload (not iframe)
      if ($bucket.hasClass('prodGalleryPopup__vidBucket--upload')) {
        var $video = $bucket.find('video');
        var video = $video.get(0);

        // Soft reinitialize the video
        video.pause();
        video.currentTime = 0;

        // Reset controls
        video.removeAttribute('controls');
        video.setAttribute('controls', 'true');

        // Reset poster to force refresh
        var poster = video.getAttribute('poster');
        video.removeAttribute('poster');
        video.setAttribute('poster', poster);

        // Force reflow to trigger repaint
        video.style.display = 'none';
        void video.offsetHeight; // trigger reflow
        video.style.display = '';

        // Optionally re-attach source (some browsers bug out on poster otherwise)
        var source = video.querySelector('source');
        if (source) {
          var src = source.getAttribute('src');
          source.setAttribute('src', src);
        }
      }
    });
  });

  $('.prodGalleryPopup__overlay, .prodGalleryPopup__close').on('click', function(){
    var thisSection = $(this).closest('.shopify-section');
    thisSection.find('.prodGalleryPopup__vidBucket').each(function(){
      $(this).html($(this).html());
      $(this).hide();
    });
    thisSection.find('.prodGalleryPopup').fadeOut();
  });

  $('.prodAccordion__titleButton').on('click', function(){
    var thisAccordion = $(this).closest('.prodAccordion');
    if (thisAccordion.hasClass("prodAccordion--active")){
      thisAccordion.removeClass("prodAccordion--active");
      thisAccordion.find('.prodAccordion__shelf').slideUp();
    }
    else{
      thisAccordion.addClass("prodAccordion--active");
      thisAccordion.find('.prodAccordion__shelf').slideDown();
    }
    
  });

  $('.prodInfo__chatButton').on('click', function(){
    $('.rp-micro-app-dummy-icon').click();
  });
});

window.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('video');

  videos.forEach(video => {
    const source = video.querySelector('source');
    const dataSrc = source.getAttribute('data-src');
    if (dataSrc) {
      source.setAttribute('src', dataSrc);
      video.load();
    }
  });
});